<template>
  <div class="box">
    <div class="work">
      <!--路径 -->
      <div class="path">
        <img class="path_img" src="../../../../../assets/images/path.png"/>
        <div class="path_txt">运营管理系统 > 快应用报表 > 快应用投放</div>
      </div>
      <!--查询条件-->
      <div class="condition">
        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label">应用:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appId" filterable  clearable  placeholder="请选择应用">
                <el-option
                        v-for="app in apps"
                        :key="parseInt(app.app_id)"
                        :label="'(' + app.app_id + ')' + app.app_name"
                        :value="parseInt(app.app_id)">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">应用类型:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.appType" filterable  clearable  placeholder="请选择应用类型">
                <el-option
                        v-for="key in Object.keys(appTypes)"
                        :key="key"
                        :label="'(' + key + ')' + appTypes[key]"
                        :value="key">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放平台：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issuePlatform" filterable clearable @change="loadIssueFlows();" placeholder="请选择投放平台">
                <el-option
                      v-for="item in issuePlatforms"
                      :key="item.issue_platform_tag"
                      :label="item.issue_platform_name"
                      :value="item.issue_platform_tag">
              </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放流量：</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issueFlow" filterable clearable placeholder="请选择投放平台流量">
                <el-option
                      v-for="item in issueFlows"
                      :key="item.issue_flow_tag"
                      :label="item.issue_flow_name"
                      :value="item.issue_flow_tag">
              </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">审核状态:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.approveStatus" clearable placeholder="所有状态">
                <el-option
                  v-for="key in Object.keys(approveStatusMap)"
                  :key="parseInt(key)"
                  :label="approveStatusMap[key]"
                  :value="parseInt(key)"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放账户:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.account" clearable placeholder="查询账户信息" />
            </div>
          </div>
        </div>

        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label">渠道:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.channelId" filterable clearable placeholder="请选择渠道">
                <el-option
                        v-for="item in channels"
                        :key="item.channel_id"
                        :label="'(' + item.channel_id + ')' + item.channel_name"
                        :value="item.channel_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">渠道位置:</div>
            <div class="condi_item_cnt">
              <el-input v-model="searchCondition.channelSlotId" clearable placeholder="请输入渠道位置" />
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">测评问题:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.measureId" filterable  clearable placeholder="请选择测评问题">
                <el-option
                        v-for="item in appraises"
                        :key="item.appraise_id"
                        :label="'(' + item.appraise_id + ')' + item.appraise_title"
                        :value="item.appraise_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">小说:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.bookId" filterable  clearable placeholder="请选择小说问题">
                <el-option
                        v-for="item in books"
                        :key="item.book_id"
                        :label="'(' + item.book_id + ')' + item.book_name"
                        :value="item.book_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">投放状态:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issueStatus" clearable placeholder="所有状态">
                <el-option
                  v-for="key in [0, 1]"
                  :key="key"
                  :label="issueStatusMap[key]"
                  :value="key"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="condi_item">
            <div class="condi_item_label">广告场景:</div>
            <div class="condi_item_cnt">
              <el-select v-model="searchCondition.issueAdScene" filterable  clearable  placeholder="请选择广告场景">
                <el-option
                        v-for="key in Object.keys(issueAdScenes)"
                        :key="parseInt(key)"
                        :label="'(' + key + ')' + issueAdScenes[key]"
                        :value="parseInt(key)">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="condi_line">
          <div class="condi_item">
            <div class="condi_item_label"></div>
            <div class="condi_item_cnt">
              <el-button type="primary" @click="onSearch">查询</el-button>
            </div>
          </div>
        </div>
      </div>
      <!--数据列表-->
      <div class="datalist">
        <div class="dtlst_top">
          <div class="dtlst_title">广告列表</div>
          <div class="dtlst_btn">
            <el-button @click="addBatch">批量新增</el-button>
            <el-button @click="add">新增</el-button>
          </div>
        </div>
        <div class="dtlst_table">
          <el-table
            :data="pageTable.tableData"
            stripe
          >
            <el-table-column prop="app_issue_id" label="ID" width="70px">
              <template slot-scope="scope">{{scope.row.app_issue_id}}</template>
            </el-table-column>
            <el-table-column prop="app_id,app_name" label="应用" width="105px">
              <template slot-scope="scope">({{scope.row.app_id}}){{scope.row.app_name}}</template>
            </el-table-column>
            <el-table-column prop="app_type" label="应用类型" width="85px">
              <template slot-scope="scope">{{scope.row.app_type ? '(' + scope.row.app_type + ')' : ''}}{{appTypes[scope.row.app_type]}}</template>
            </el-table-column>
            <el-table-column prop="issue_flow" label="投放流量" width="105px">
              <template slot-scope="scope">{{scope.row.issue_flow && issueFlows.find(item=>item.issue_flow_tag==scope.row.issue_flow) ? issueFlows.find(item=>item.issue_flow_tag==scope.row.issue_flow).issue_flow_name : ''}}</template>
            </el-table-column>
            <el-table-column prop="issue_account" label="投放账号" width="200px">
              <template slot-scope="scope">{{scope.row.issue_target ? '[计划]':'[帐户]'}}{{scope.row.issue_account}}</template>
            </el-table-column>
            <el-table-column prop="channel_id,channel_name" width="140px" label="渠道">
              <template slot-scope="scope">({{scope.row.channel_id}}){{scope.row.channel_name}}</template>
            </el-table-column>
            <el-table-column prop="channel_slot_id" width="80px" label="渠道位置">
              <template slot-scope="scope">{{scope.row.channel_slot_id}}</template>
            </el-table-column>
            <el-table-column prop="measure_id,measure_title" label="投放内容" width="200px">
              <template slot-scope="scope">
                {{scope.row.book_id && books.find(item => item.book_id == scope.row.book_id) ? '[说]' + books.find(item => item.book_id == scope.row.book_id).book_name : ''}}
                {{scope.row.measure_id && appraises.find(item => item.appraise_id == scope.row.measure_id) ? '[测]' + appraises.find(item => item.appraise_id == scope.row.measure_id).appraise_title : ''}}
                {{scope.row.shortplay_id && scope.row.app_id!=30 && shortplays.find(item => item.shortplay_id == scope.row.shortplay_id) ? '[剧]' + shortplays.find(item => item.shortplay_id == scope.row.shortplay_id).shortplay_name : ''}}
                
                {{scope.row.shortplay_id && scope.row.app_id==30 && scope.row.app_type==61 && oshortplays.find(item => item.shortplay_id == scope.row.shortplay_id) ? '[剧]' + oshortplays.find(item => item.shortplay_id == scope.row.shortplay_id).shortplay_name : ''}}
                {{scope.row.shortplay_id && scope.row.app_id==30 && scope.row.app_type==62 && vshortplays.find(item => item.shortplay_id == scope.row.shortplay_id) ? '[剧]' + vshortplays.find(item => item.shortplay_id == scope.row.shortplay_id).shortplay_name : ''}}
                
                {{scope.row.cookbook_id ? '[菜]' + cookbooks[scope.row.cookbook_id] : ''}}
                {{scope.row.health_class_id!=undefined ? '[养分]' + health_classes[scope.row.health_class_id] : ''}}
                {{scope.row.health_id ? '[养]' + healthes[scope.row.health_id] : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="issue_effect_type" label="效果回传" width="110px">
              <template slot-scope="scope">
                {{issueEffects.find(item=>item.issue_platform_tag==scope.row.issue_platform && item.issue_effect_tag==scope.row.issue_effect_type) ? issueEffects.find(item=>item.issue_platform_tag==scope.row.issue_platform && item.issue_effect_tag==scope.row.issue_effect_type).issue_effect_name : ''}}
              </template>
            </el-table-column>
            <el-table-column prop="issue_status" label="审核状态" width="90">
              <template slot-scope="scope">
                <el-tag width="60" type="primary" v-if="scope.row.approve_status==0">{{approveStatusMap[scope.row.approve_status]}}</el-tag>
                <el-tag width="60" type="danger" v-else-if="scope.row.approve_status==1">{{approveStatusMap[scope.row.approve_status]}}</el-tag>
                <el-tag width="60" type="success" v-else-if="scope.row.approve_status==2">{{approveStatusMap[scope.row.approve_status]}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="issue_status" label="状态" width="80">
              <template slot-scope="scope">
                <el-tag width="60" type="danger" v-if="scope.row.issue_status==0 || scope.row.issue_debug==1">{{issueStatusMap[scope.row.issue_status]}}</el-tag>
                <el-tag width="60" v-else>{{issueStatusMap[scope.row.issue_status]}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="350">
              <template slot-scope="scope">
                <div class="dtlst_operation">
                  <el-button type="primary" size="small" @click="configEffect(scope.row.channel_slot_id)">回传</el-button>
                  <el-button type="success" size="small" @click="audit(scope.row)">审核通过</el-button>
                  <el-button type="info" size="small" @click="copy(scope.row)">复制</el-button>
                  <el-button type="primary" size="small" @click="update(scope.row)">编辑</el-button>
                  <el-button type="danger" size="small" @click="remove(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="dtlst_pagination">
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="pageTable.pageIndex"
              :page-size="pageTable.pageSize"
              :page-sizes="[5, 10, 20, 50, 100, 200, 500]" 
              :page-count="pageTable.pageCount"
              :total="pageTable.recordTotalCount"
              @current-change="changeCurrPage"
              @size-change="changePageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>

      <!--效果数据回传设置弹窗-->
      <el-dialog title="效果数据回传设置" 
        :visible.sync="dialogConfigEffectVisible" 
        :close-on-click-modal="false"
        width="950px"
        center>
        <el-form :model="formConfigEffect" ref="formConfigEffect" :rules="configEffectRules">
          <el-form-item label="渠道位置: " prop="channelSlotId" label-width="100px">
            <el-input v-model="formConfigEffect.channelSlotId" v-if="editStatChanneSlot" autocomplete="off" style="width:200px;"></el-input>
            <el-input v-model="formConfigEffect.channelSlotId" v-if="!editStatChanneSlot" readonly autocomplete="off" style="width:200px;"></el-input>
            &nbsp;
            <el-button @click="changeChannelSlot" v-if="!editStatChanneSlot">修改</el-button>
            <el-button @click="confirmChannelSlot" v-if="editStatChanneSlot">确定</el-button>
            <el-button @click="cancelChannelSlot" v-if="editStatChanneSlot">取消</el-button>
          </el-form-item>
          <el-form-item label="回传模式：" label-width="100px">
            <el-checkbox-group v-model="effectModeSelected" onchange="configEffectModeChange();">
              <el-checkbox-button v-for="mode in effectModes" :label="mode" :key="mode">{{mode}}</el-checkbox-button>
            </el-checkbox-group>
            <el-checkbox-group v-model="effectModeSelected2" onchange="configEffectModeChange();">
              <el-checkbox-button v-for="mode in effectModes2" :label="mode" :key="mode">{{mode}}</el-checkbox-button>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="回传比例:" prop="effectRate" label-width="100px">
              <el-input v-model="formConfigEffect.effectRate" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;%
          </el-form-item>
          <el-form-item label="广告点击:" prop="effectAdClick" label-width="100px">
              <el-input v-model="formConfigEffect.effectAdClick" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;次
          </el-form-item>
          <el-form-item label="广告曝光:" prop="effectAdView" label-width="100px">
              <el-input v-model="formConfigEffect.effectAdView" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
              <el-input v-model="formConfigEffect.effectAdView2" clearable autocomplete="off" style="width:200px;" v-if="effectModeSelected2 && effectModeSelected2.find(item => item=='用户ARPU3')!=undefined"></el-input>&nbsp;次
          </el-form-item>
          <el-form-item label="广告价格:" prop="effectAdPrice" label-width="100px">
              <el-input v-model="formConfigEffect.effectAdPrice" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;元（eCPM）
          </el-form-item>
          <el-form-item label="用户ARPU:" prop="effectArpu" label-width="100px">
              <el-input v-model="formConfigEffect.effectArpu" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
              <el-input v-model="formConfigEffect.effectArpu2" clearable autocomplete="off" style="width:200px;" v-if="effectModeSelected2 && effectModeSelected2.find(item => item=='用户ARPU3')!=undefined"></el-input>&nbsp;元
          </el-form-item>
          <el-form-item label="访问时长:" prop="effectDuration" label-width="100px">
              <el-input v-model="formConfigEffect.effectDuration" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;秒
          </el-form-item>
          <el-form-item label="ROI:" prop="effectRoi" label-width="100px">
              <el-input v-model="formConfigEffect.effectRoi" clearable autocomplete="off" style="width:200px;"></el-input>&nbsp;
          </el-form-item>
          <el-form-item label="忽略设备:" label-width="100px">
              <el-checkbox v-model="effectIgnoreOppo" style="width:100px;">忽略OPPO</el-checkbox>
              <el-checkbox v-model="effectIgnoreVivo" style="width:100px;">忽略VIVO</el-checkbox>
              <el-checkbox v-model="effectUnifySwitch" style="width:100px;">统一回传</el-checkbox>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="onCancelConfigEffect">取 消</el-button>
          <el-button type="primary" @click="submitConfigEffect('formConfigEffect')">确 定</el-button>
          <el-button type="info" @click="showOperateLogs">历史操作</el-button>
        </div>
      </el-dialog>

      <!--操作日志查询-->
      <el-dialog title="效果数据回传历史修改记录" 
        :visible.sync="dialogOperateLogVisible" 
        :close-on-click-modal="false"
        width="1000px"
        center>
        
        <div class="dtlst_table">
          <el-table
            :data="operateLogs.tableData"
            stripe
          >
            <el-table-column prop="operate_time" label="时间" width="200px">
              <template slot-scope="scope">{{scope.row.operate_time}}</template>
            </el-table-column>
            <el-table-column prop="operator_name" label="操作人" width="150px">
              <template slot-scope="scope">{{scope.row.operator_name}}</template>
            </el-table-column>
            <el-table-column prop="change_illustrate" label="操作详情" width="600px">
              <template slot-scope="scope">
                <span style="white-space:pre-line;">
                  {{scope.row.change_illustrate}}
                </span>
              </template>
            </el-table-column>
          </el-table>
          <div class="dtlst_pagination">
            <el-select v-model="operateLogs.dateRange" @change="loadOperateLogs()" placeholder="请选择日志时间范围">
              <el-option
                v-for="item in logDateRange"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <el-pagination
              background
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="operateLogs.pageIndex"
              :page-size="operateLogs.pageSize"
              :page-sizes="[100, 200, 500, 1000]" 
              :page-count="operateLogs.pageCount"
              :total="operateLogs.recordTotalCount"
              @current-change="changeOperateLogCurrPage"
              @size-change="changeOperateLogPageSize"
            >
            </el-pagination>
          </div>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import {MessageBox} from 'element-ui';

import {
  getCurrDate,
  getCurrDateTime,
  getBeforeDate
} from '../../../../../assets/scripts/date2string';

import {
  QuickAppConfig
} from '../../../../../assets/scripts/appconfig';

export default {
  data() {
    return {
      // 操作员对象
      operator: null,

      // 分页表格
      pageTable: {
        pageIndex: 1,         //当前页索引
        pageSize: 100,        //本页显示数量
        pageCount: 1,         //分页总数
        recordTotalCount: 0,  //记录
        tableData: [],        // 应用列表数据
      },
      
      // 搜索的参数
      searchCondition: {
        appId: null,          //应用ID
        appType: null,        //应用类型
        issuePlatform: null,  //投放平台
        issueFlow: null,      //投放平台流量
        measureId: null,      //测评ID
        bookId: null,         //小说ID
        channelId: null,      //渠道ID
        channelSlotId: null,  //渠道位置ID
        account: null,        //投放账户信息
        issueAdScene: null,   //投放广告场景
        issueStatus: 1,       //投放状态
      },

      apps: null,             // 应用集合
      channels: null,         // 渠道列表

      appraises: null,        //测评列表(新)
      appraiseTemplets: null, //测评模版映射表(新)

      books: null,            //小说
      bookNames: null,        //小说名称

      shortplays: null,       //短剧
      vshortplays: null,      //vivo 短剧
      oshortplays: null,      //oppo 短剧

      // 投放平台、流量、效果列表
      issuePlatforms: [],
      issueFlows: [],
      issueEffects: [],
      
      // 应用类型
      appTypes: {
        5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },

      // 菜谱
      cookbooks: {
        1:    '红烧肉',
        2:	  '排骨玉米汤',
        3:	  '鱼香肉丝',
        4:	  '炸酱面',
        5:	  '糖醋排骨',
        6:	  '可乐鸡翅',
        7:	  '红焖羊排萝卜',
        8:	  '木须肉',
        9:	  '酸辣土豆丝',
        10:	  '芒果圆子西米露',
        11:   '白菜豆腐煲',
        12:	  '油闷大虾',
        13:	  '煎蛋白菜豆腐汤',
        14:	  '照烧肥牛饭',
        15:   '东北锅包肉',
        16:   '家庭版葡式蛋挞',
        17:	  '秋葵',
        18:	  '三鲜饺子',
        19:	  '咖喱鸡肉饭',
        20:	  '酸辣汤',
        99999:'转盘'
      },

      // 健康养生
      healthes: {
        1:    '警惕亚健康，守护生命活力',
        2:	  '如何呵护颈椎健康',
        3:	  '如何远离腰椎问题',
        4:	  '关注 “工作病”，守护职场健康',
        5:	  '女性经期养生指南',
        6:	  '孕期养生指南',
        7:	  '老年人如何吃才健康？',
        8:	  '老年常见疾病如何预防？',
        9:	  '运动，让老人更健康的秘诀',
        10:	  '老年人觉少正常吗？',
        11:   '解压木鱼真的解压吗',
        12:	  '音乐如何助眠',
        13:	  '摆脱睡眠困扰',
        14:	  '冥想的妙用',
        15:   '冥想，减压神器',
        16:   '音乐，让睡眠更轻松',
        17:	  '常见食材的养生功效',
        18:	  '慢食文化与健康',
        19:	  '胶原蛋白的秘密',
        20:	  '食物搭配禁忌表',
        21:   '暖冬滋补秘籍',
        22:   '顺应节气，吃出健康',
        23:   '如何健康瘦？',
        24:   '八段锦古法养生',
        25:   '上班族如何保持日常运动',
        26:   '日常运动养生小技巧',
        27:   '瑜伽的好处',
        28:   '传统健身的养生智慧',
        29:   '选择合适的户外运动',
        30:   '科学健身',
      },

      health_classes: {
        0:    '食材养生',
        1:	  '冥想疗愈',
        2:	  '运动养生',
        3:	  '养生人群',
      },
      
      // 广告资源位打底广告场景
      adResourceBidbases: {
        1: '打底场景 1',
        2: '打底场景 2',
        3: '打底场景 3',
        4: '打底场景 4',
        5: '打底场景 5',
      },

      // 广告场景
      issueAdScenes: {
        1: '广告场景 1',
        2: '广告场景 2',
        3: '广告场景 3',
        4: '广告场景 4',
        5: '广告场景 5',
      },
      
      // 状态
      issueStatusMap: {
        1: "有效",
        0: "无效"
      },    
      
      // 审核状态
      approveStatusMap: {
        0:  "待审核",
        1:  "审核不通过",
        2:  "审核通过"
      },
      
      /********* 效果数据回传 **********/
      dialogConfigEffectVisible: false,
      formConfigEffect: {
        operatorId: null,
        channelSlotId: null,
        effectMode: null,
        effectRate: null,
        effectAdClick: null,
        effectAdView: null,
        effectAdView2: null,
        effectArpu: null,
        effectArpu2: null,
        effectAdPrice: null,
        effectDuration: null,
        effectRoi: null,
        effectIgnore: null,
        effectUnify: null,
      },
      effectIgnoreOppo: false,
      effectIgnoreVivo: false,
      effectUnifySwitch: false,
      
      editChannelSlotId: null,
      editStatChanneSlot: false,

      effectModes: ['广告点击','广告曝光','用户ARPU','广告价格','访问时长','广告曝光&价格','ROI'],
      effectModeSelected: [],
      effectModes2: ['广告点击&价格','用户ARPU2','广告价格2','广告曝光&价格2','收入ROI','ROI修正'],
      effectModeSelected2: [],
      
      // 效果数据回传校验规则
      configEffectRules: {
          channelSlotId: [
              { required: true, message: '无效的渠道位置', trigger: 'blur' }
          ],
          effectMode: [
              { required: true, message: '请选择效果回传模式', trigger: 'blur' }
          ],
          effectRate: [
              { required: true, message: '请输入效果回传比例', trigger: 'blur' }
          ]   
      },
      /*********************************/

      /************操作日志**************/
      dialogOperateLogVisible: false,
      operateLogs: {
        dateRange: 3,
        pageIndex: 1,         // 当前页索引
        pageSize: 100,        // 本页显示数量
        pageCount: 1,         // 分页总数
        recordTotalCount: 0,  // 记录
        tableData: [],        // 应用列表数据
      },
      logDateRange: [{
          value: 3,
          label: '最近3天'
        },
        {
          value: 7,
          label: '最近7天'
        },
        {
          value: 15,
          label: '最近15天'
        },
        {
          value: 30,
          label: '最近30天'
        }
      ],
      /*********************************/
      
    }
  },
  
  created() {
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 从缓存中恢复查询条件
    let sc = localStorage.getItem('sc.quickstat.issue');
    if(sc && sc.length>0) {
      let lsc = JSON.parse(sc);
      if(lsc.timestamp && (new Date().getTime() - lsc.timestamp) <= 30 * 60 * 1000) {
        this.searchCondition = lsc.data;
      } else {
        localStorage.removeItem('sc.quickstat.issue');
      }
    }
    // 初始化数据
    this.initApps();
    this.initChannels();
    this.initAppraises();
    this.initBooks();
    this.initShortplays();
    this.initIssuePlatforms();
    this.loadIssueFlows();
    this.loadIssueEffects();
    // 加载数据
    this.loadData();
  },
  
  methods: {
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = null;
      // 调用接口
      let res = await this.$api.apiCommonApps();
      // 应用数据存进data
      this.apps = res.content;
    },

    // 初始化渠道
    async initChannels() {
      // 清空当前渠道
      this.channels = [];
      // 调用接口
      let res = await this.$api.apiCommonChannels();
      // 保存结果
      this.channels = res.content;
    },

    // 初始化测评(新)
    async initAppraises() {
      // 清空当前测评
      this.appraises = [];
      // 调用接口
      let res = await this.$api.apiCommonAppraises();
      // 保存结果
      this.appraises = res.content;
      // 保存测评模版映射
      this.appraiseTemplets = {};
      this.appraises.forEach((appraise) => {
        this.appraiseTemplets[appraise.appraise_id] = appraise.templet_tag ? appraise.templet_tag : 'tpltxt_question';
      });
    },

    // 初始化小说
    async initBooks() {
      // 清空当前测评
      this.books = [];
      // 调用接口
      let res = await this.$api.apiCommonBooks();
      // 保存结果
      this.books = res.content;
      // 保存小说名称
      this.bookNames = {};
      this.books.forEach((book) => {
        this.bookNames[book.book_id] = book.book_name;
      });
    },

    // 初始化短剧
    async initShortplays() {
      // 加载短剧
      this.shortplays = null;
      let res = await this.$api.apiCommonShortplays();
      this.shortplays = res.content;

      // 加载 vivo 短剧
      this.vshortplays = null;
      res = await this.$api.apiCommonVshortplays();
      this.vshortplays = res.content;

      // 加载 oppo 短剧
      this.oshortplays = null;
      res = await this.$api.apiCommonOshortplays();
      this.oshortplays = res.content;
    },

    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = [];
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },

    // 加载发布平台流量类型
    async loadIssueFlows() {
      // 清空当前流量类型
      this.searchCondition.issueFlow = null;
      this.issueFlows = [];
      // 调用接口
      let res = await this.$api.apiCommonIssueFlows({issuePlatformTag: this.searchCondition.issuePlatform});
      // 保存结果
      this.issueFlows = res.content;
    },

    // 加载发布平台效果数据回传类型
    async loadIssueEffects() {
      // 调用接口
      let res = await this.$api.apiCommonIssueEffects();
      // 保存结果
      this.issueEffects = res.content;
    },
    
    // 加载数据
    async loadData() {
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['pageIndex'] = this.pageTable.pageIndex;
      params['pageSize'] = this.pageTable.pageSize;
      params['operatorId'] = this.operator.operatorId;
      params['appId'] = this.searchCondition.appId;
      params['appType'] = this.searchCondition.appType;
      params['issuePlatform'] = this.searchCondition.issuePlatform;
      params['issueFlow'] = this.searchCondition.issueFlow;
      params['channelId'] = this.searchCondition.channelId;
      params['channelSlotId'] = this.searchCondition.channelSlotId;
      params['measureId'] = this.searchCondition.measureId;
      params['bookId'] = this.searchCondition.bookId;
      params['account'] = this.searchCondition.account;
      params['issueAdScene'] = this.searchCondition.issueAdScene;
      params['issueStatus'] = this.searchCondition.issueStatus;
      params['approveStatus'] = this.searchCondition.approveStatus;
      // 清空当前集合数据
      this.pageTable.tableData = [];
      // 调用接口
      let res = await this.$api.apiQuickAppIssueList(params);
      if(res.result !== 1) {
        this.$message("加载数据列表失败","warning");
        // 加载结束
        loading.close();
        return;
      }
      // 获取分页数据
      this.pageTable.pageIndex = res.content.pageIndex;
      this.pageTable.pageSize = res.content.pageSize;
      this.pageTable.pageCount = res.content.pageCount;
      this.pageTable.recordTotalCount = res.content.recordTotalCount;
      // 应用数据存进data
      this.pageTable.tableData = res.content.records;
      // 加载结束
      loading.close();
    },
    
    // 搜索应用
    async onSearch(){
      // 保存查询条件
      localStorage.setItem('sc.quickstat.issue', JSON.stringify({
        'data': this.searchCondition,
        'timestamp': new Date().getTime()
      }));
      // 先清空原有数据
      this.pageTable.tableData = [];
      // 查询应用
      this.loadData();
    },

    // 审核通过
    async audit(issue) {
      // 数据验证
      if(issue.approve_status==2) {
        this.$message("不需要重复审核", "warning");
        return;
      }
      if(issue.issue_status!=1) {
        this.$message("应用投放无效，无法审核", "warning");
        return;
      }
      if(!issue.app_id) {
        this.$message("应用未设置，无法审核通过", "warning");
        return;
      }
      if(!issue.channel_id || !issue.channel_slot_id) {
        this.$message("渠道未设置，无法审核通过", "warning");
        return;
      }
      if(!issue.issue_platform) {
        this.$message("投放平台未设置，无法审核通过", "warning");
        return;
      }
      // 判断回传设置是否正常
      let res = await this.$api.apiCommonEffectGet({channelSlotId: issue.channel_slot_id});
      if(!res.result || res.result==1 && !res.content.effectMode) {
        this.$message("审核通过前需先设置回传.", "warning");
        return;
      }
      // 生成快应用链接
      if(this.apps.find(item => item.app_id == issue.app_id).business_line == 'quickapp') {
        if(!this.generateIssueQuickapp(issue))
          return;
      }
      // 生成wechat h5 应用链接
      if(this.apps.find(item => item.app_id == issue.app_id).business_line == 'appraise_pay') {
        if(!this.generateIssueWechatH5(issue))
          return;
      }
      // 显示页面加载
      const loading = this.$loading({
        lock: true,
        text: 'Processing ......',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: '.box'
      });
      // 设置投放时间
      issue.issue_time = getCurrDateTime();
      // 设置审核通过
      issue.approve_status = 2;
      // 调用新增接口
      this.$api.apiQuickAppIssueUpdate(issue).then (res => {
        if (res.result === 1) {
          // 请求成功
          this.$message("应用投放审核通过", "success");
          // 列表刷新
          this.loadData();
        } else {
          this.$message(res.message, "warning");
        }
      });
      // 关闭加载
      loading.close();    
    },
    
    // 生成Wechat H5应用链接
    generateIssueWechatH5(issue) {
      // 验证参数
      if(issue.issue_platform=='gdt' && !issue.issue_account) {
        this.$message("请先完善广点通投放账号信息", "warning");
        return false;
      }
      // 设置应用类型
      issue.app_type = this.apps.find(item => item.app_id == issue.app_id).app_type;
      // 定义目标页面
      let sip = '';
      // 针对不同投放平台，生成监测链接
      if(issue.issue_platform=='gdt') {
        sip = 'tg';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__AD_ID__&creativeid=__DYNAMIC_CREATIVE_ID__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__AD_ID__&creativeid=__DYNAMIC_CREATIVE_ID__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
      } else {
        sip = 'common';
        issue.issue_tc_url = '';
        issue.issue_tv_url = '';
      }

      // 基于应用，生成投放链接
      if(issue.app_id==23) {
        issue.issue_h5_url = 'https://coscdn.aiseeking.com/appraisepay/wh5/mbti/v3/index.html?sip=' + sip + '5&cid='+ issue.channel_id + '&csid=' + issue.channel_slot_id;
      }
      return true;
    },

    // 生成快应用链接
    generateIssueQuickapp(issue) {
      // 验证参数正确性
      if(issue.issue_platform=='oppo' && (!issue.issue_account || !issue.oppo_api_id || !issue.oppo_api_key)) {
        this.$message("请先完善OPPO投放账号信息", "warning");
        return false;
      }
      if(issue.issue_platform=='vivo' && (!issue.issue_account || !issue.vivo_api_ds || !issue.issue_effect_type)) {
        this.$message("请先完善VIVO投放账号信息", "warning");
        return false;
      }
      if(issue.issue_platform=='huawei' && (!issue.issue_account || !issue.issue_account_key)) {
        this.$message("请先完善华为投放账号信息", "warning");
        return false;
      }
      if(issue.issue_platform=='toutiao' && (!issue.issue_account || !issue.issue_effect_type)) {
        this.$message("请先完善头条投放账号信息", "warning");
        return false;
      }
      if(issue.issue_platform=='kuaishou' && !issue.issue_account) {
        this.$message("请先完善快手投放账号信息", "warning");
        return false;
      }
      if(issue.issue_platform=='qtt' && !issue.issue_account) {
        this.$message("请先完善趣头条投放账号信息", "warning");
        return false;
      }
      if(issue.issue_platform=='baidu' && (!issue.issue_account || !issue.issue_account_name || !issue.baidu_api_akey)) {
        this.$message("请先完善百度投放账号信息", "warning");
        return false;
      }

      // 定义目标页面
      let target = '';
      let sip = '';
      
      // 针对不同投放平台，生成监测链接
      if(issue.issue_platform=='oppo') {
        target = 'oppo';
        sip = 'ou';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=oppo&os=$os$&osVersion=$ov$&model=$m$&lang=$lan$&country=$c$&width=$w$&height=$h$&pkg=$pkg$&appVersion=$av$&userAgent=$ua$&referer=$rf$&net=$nt$&imei=$im$&oaid=__OAID__&adid=$ad$&adname=$an$&reqid=$req$';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=oppo&os=$os$&osVersion=$ov$&model=$m$&lang=$lan$&country=$c$&width=$w$&height=$h$&pkg=$pkg$&appVersion=$av$&userAgent=$ua$&referer=$rf$&net=$nt$&imei=$im$&oaid=__OAID__&adid=$ad$&adname=$an$&reqid=$req$';
      } else if(issue.issue_platform=='vivo') {
        target = 'vivo';
        sip = 'vu';
        // issue.issue_tc_url = 'https://qapi.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&creativeid=__CREATIVEID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&ts=__TS__';
        // issue.issue_tv_url = 'https://qapi.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&creativeid=__CREATIVEID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&ts=__TS__';
        // issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&creativeid=__CREATIVEID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&ts=__TS__';
        // issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&creativeid=__CREATIVEID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&ts=__TS__';
        issue.issue_tc_url = 'https://qapi.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&adid=__ADID__&clickid=__CLICKID__&ts=__TS__';
        issue.issue_tv_url = 'https://qapi.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=vivo&os=__OS__&osVersion=__OSVERSION__&imei=__IMEI__&oaid=__OAID__&userAgent=__UA__&model=__MODEL__&lang=__LANG__&reqid=__REQUESTID__&net=__NETTYPE__&adname=__ADNAME__&ip=__IP__&location=__LOCATION__&oaidplain=__OAIDPLAIN__&androidid=__ANDROIDID__&reqtime=__REQUESTTIME__&advertiserid=__ADVERTISERID__&resolution=__RESOLUTION__&rtaexp=__RTAEXP__&adid=__ADID__&clickid=__CLICKID__&ts=__TS__';
      } else if(issue.issue_platform=='huawei') {
        target = 'issue';
        sip = 'hw';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=huawei';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=huawei';
      } else if(issue.issue_platform=='qtt') {
        target = 'qtt';
        sip = 'qt';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=qtt&os=__OS__&imei=__IMEIMD5__&width=__SCREEN_WIDTH__&height=__SCREEN_HEIGHT__&userAgent=__UA__&ip=__IP__&oaidplain=__OAID__&oaid=__OAIDMD5__&referer=__CALLBACK_URL__&ts=__TS__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=qtt&os=__OS__&imei=__IMEIMD5__&width=__SCREEN_WIDTH__&height=__SCREEN_HEIGHT__&userAgent=__UA__&ip=__IP__&oaidplain=__OAID__&oaid=__OAIDMD5__&referer=__CALLBACK_URL__&ts=__TS__';
      } else if(issue.issue_platform=='kuaishou') {
        target = 'issue';
        sip = 'ks';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=kuaishou&advertiserid=__ACCOUNTID__&adid=__AID__&creativeid=__CID__&oaidplain=__OAID__&oaid=__OAID2__&imei=__IMEI2__&androidid=__ANDROIDID2__&os=__OS__&model=__MODEL__&ip=__IP__&referer=__CALLBACK__&userAgent=__UA__&ts=__TS__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=kuaishou&advertiserid=__ACCOUNTID__&adid=__AID__&creativeid=__CID__&oaidplain=__OAID__&oaid=__OAID2__&imei=__IMEI2__&androidid=__ANDROIDID2__&os=__OS__&model=__MODEL__&ip=__IP__&referer=__CALLBACK__&userAgent=__UA__&ts=__TS__';
      } else if(issue.issue_platform=='toutiao') {
        target = 'tt';
        sip = 'tt';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=toutiao&advertiserid=__ADVERTISER_ID__&adid=__PROMOTION_ID__&adname=__PROMOTION_NAME__&ip=__IP__&os=__OS__&model=__MODEL__&imei=__IMEI__&oaid=__OAID_MD5__&oaidplain=__OAID__&userAgent=__UA__&androidid=__ANDROIDID__&ts=__TS__&reqid=__REQUEST_ID__&referer=__CALLBACK_PARAM__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=toutiao&advertiserid=__ADVERTISER_ID__&adid=__PROMOTION_ID__&adname=__PROMOTION_NAME__&ip=__IP__&os=__OS__&model=__MODEL__&imei=__IMEI__&oaid=__OAID_MD5__&oaidplain=__OAID__&userAgent=__UA__&androidid=__ANDROIDID__&ts=__TS__&reqid=__REQUEST_ID__&referer=__CALLBACK_PARAM__';
      } else if(issue.issue_platform=='gdt') {
        target = 'issue';
        sip = 'tg';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__ADGROUP_ID__&adname=__ADGROUP_NAME__&creativeid=__DYNAMIC_CREATIVE_ID__&location=__SITE_SET_NAME__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=gdt&advertiserid=__ACCOUNT_ID__&adid=__ADGROUP_ID__&adname=__ADGROUP_NAME__&creativeid=__DYNAMIC_CREATIVE_ID__&location=__SITE_SET_NAME__&ip=__IP__&os=__DEVICE_OS_TYPE__&imei=__MUID__&oaid=__HASH_OAID__&reqid=__CLICK_ID__&reqtime=__CLICK_TIME__&referer=__CALLBACK__&rtaexp=__REQUEST_ID__&resolution=__IMPRESSION_ID__&userAgent=__USER_AGENT__';
      } else if(issue.issue_platform=='alipay') {
        target = 'issue';
        sip = 'ap';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=alipay&os=__OS__&ip=__IP__&imei=__IMEI__&oaid=__OAID_MD5__&model=__IDFA_MD5__&advertiserid=__PRINCIPAL_ID__&adid=__GROUP_ID__&creativeid=__AD_ID__&resolution=__CID__&rtaexp=__CAID__&androidid=__OPENID__&reqid=__REQUEST_ID__&ts=__TS__&reqtime=__ET__&referer=__CALLBACK_EXT_INFO__&userAgent=__UA__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=alipay&os=__OS__&ip=__IP__&imei=__IMEI__&oaid=__OAID_MD5__&model=__IDFA_MD5__&advertiserid=__PRINCIPAL_ID__&adid=__GROUP_ID__&creativeid=__AD_ID__&resolution=__CID__&rtaexp=__CAID__&androidid=__OPENID__&reqid=__REQUEST_ID__&ts=__TS__&reqtime=__ET__&referer=__CALLBACK_EXT_INFO__&userAgent=__UA__';
      } else if(issue.issue_platform=='baidu') {
        target = 'baidu';
        sip = 'bu';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=baidu&callType=v2&referer=' + issue.baidu_api_akey + '&os=__OS__&resolution={{SIZE}}&oaidplain=__OAID__&oaid=__OAID_MD5__&imei=__IMEI_MD5__&ip=__IP__&userAgent=__UA__&androidid=__ANDROID_ID__&advertiserid=__USER_ID__&adid=__PLAN_ID__&creativeid=__IDEA_ID__&reqid=__CLICK_ID__&rtaexp=__EXT_INFO__&ts=__TS__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=baidu&callType=v2&referer=' + issue.baidu_api_akey + '&os=__OS__&resolution={{SIZE}}&oaidplain=__OAID__&oaid=__OAID_MD5__&imei=__IMEI_MD5__&ip=__IP__&userAgent=__UA__&androidid=__ANDROID_ID__&advertiserid=__USER_ID__&adid=__PLAN_ID__&creativeid=__IDEA_ID__&reqid=__CLICK_ID__&rtaexp=__EXT_INFO__&ts=__TS__';
      } else if(issue.issue_platform=='uc') {
        target = 'uc';
        sip = 'uc';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=uc&advertiserid={ACID}&adid={AID}&creativeid={CID}&os={OS_ID}&model={MODEL1}&ip={IP}&oaid={OAID_SUM}&oaidplain={OAID}&imei={IMEI_SUM}&net={IMEI_SUM1}&referer={CALLBACK_URL}&userAgent={UA}&ts={UX_TS}';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=uc&advertiserid={ACID}&adid={AID}&creativeid={CID}&os={OS_ID}&model={MODEL1}&ip={IP}&oaid={OAID_SUM}&oaidplain={OAID}&imei={IMEI_SUM}&net={IMEI_SUM1}&referer={CALLBACK_URL}&userAgent={UA}&ts={UX_TS}';
      } else if(issue.issue_platform=='wifi') {
        target = 'wifi';
        sip = 'wf';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=wifi&advertiserid=__AID__&creativeid=__CID__&adid=__UID__&reqid=__SID__&reqtime=__STIME__&model=__MAC__&androidid=__ANDROID_ID__&imei=__IMEI__&os=__OS__&ip=__IP__&oaid=__HASH_OAID__&oaidplain=__OAID__&referer=__CALLBACK_URL__&userAgent=__UA__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=wifi&advertiserid=__AID__&creativeid=__CID__&adid=__UID__&reqid=__SID__&reqtime=__STIME__&model=__MAC__&androidid=__ANDROID_ID__&imei=__IMEI__&os=__OS__&ip=__IP__&oaid=__HASH_OAID__&oaidplain=__OAID__&referer=__CALLBACK_URL__&userAgent=__UA__';
      } else if(issue.issue_platform=='iqiyi') {
        target = 'iqiyi';
        sip = 'qy';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=iqiyi&advertiserid=__ADVERTISER_ID__&creativeid=__CREATIVE_ID__&reqid=__IMPRESSS_ID__&androidid=__ANDROIDID__&os=__OS__&osVersion=__OS_VERSION__&model=__CELL_PHONE_MANUFACTURER__&net=__MAC__&ip=__IP__&oaid=__OAID_MD5__&oaidplain=__OAID__&imei=__IMEI__&referer=__CALLBACK_URL__&userAgent=__UA__&ts=__TS_MS__&rtaexp=__SIGN__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=iqiyi&advertiserid=__ADVERTISER_ID__&creativeid=__CREATIVE_ID__&reqid=__IMPRESSS_ID__&androidid=__ANDROIDID__&os=__OS__&osVersion=__OS_VERSION__&model=__CELL_PHONE_MANUFACTURER__&net=__MAC__&ip=__IP__&oaid=__OAID_MD5__&oaidplain=__OAID__&imei=__IMEI__&referer=__CALLBACK_URL__&userAgent=__UA__&ts=__TS_MS__&rtaexp=__SIGN__';
      } else if(this.formData.issue_platform=='weibo') {
        target = 'issue';
        sip = 'wb';
        issue.issue_tc_url = 'https://tracking.aiseeking.com/tracking/v1/quick/click?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=weibo&os=__OS__&osVersion=__OSVERSION__&ip=__IP__&net=__MAC1__&model=__MODEL__&lang=__SL__&imei=__IMEI__&oaid=__OAID_MD5__&androidid=__ANDROIDID__&advertiserid=__ADVERTISER_ID__&creativeid=__TSID__&adid=__AID__&adname=__AID_NAME__&referer=__CALLBACK_PARAM__&userAgent=__UA__&ts=__TS__';
        issue.issue_tv_url = 'https://tracking.aiseeking.com/tracking/v1/quick/view?appid=' + issue.app_id + '&apptype=' + issue.app_type + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&target=weibo&os=__OS__&osVersion=__OSVERSION__&ip=__IP__&net=__MAC1__&model=__MODEL__&lang=__SL__&imei=__IMEI__&oaid=__OAID_MD5__&androidid=__ANDROIDID__&advertiserid=__ADVERTISER_ID__&creativeid=__TSID__&adid=__AID__&adname=__AID_NAME__&referer=__CALLBACK_PARAM__&userAgent=__UA__&ts=__TS__';
      } else {
        target = 'issue';
        sip = 'common';
        issue.issue_tc_url = '';
        issue.issue_tv_url = '';
      }

      // 针对不同应用类型生成链接
      if(QuickAppConfig[String(issue.app_id)]['type']=='app') {
        issue.issue_h5_url = 'https://coscdn.' + QuickAppConfig[String(issue.app_id)]['domain'] + '.com' + QuickAppConfig[String(issue.app_id)]['path'] + QuickAppConfig[String(issue.app_id)]['name'] + '_' + target + '.html?sip=' + sip + '5&cid='+ issue.channel_id + '&csid=' + issue.channel_slot_id + (issue.measure_id && issue.measure_id!='' ? '&mid=' + issue.measure_id + '&mtp=' + this.appraiseTemplets[issue.measure_id] : '') + (issue.book_id && issue.book_id!='' ? '&bid=' + issue.book_id + '&bnm=' + encodeURIComponent(this.bookNames[issue.book_id]) : '') + (issue.shortplay_id && issue.shortplay_id!='' ? '&vid=' + issue.shortplay_id : '') + (issue.cookbook_id && issue.cookbook_id!='' ? '&nid=' + issue.cookbook_id : '') + (issue.health_class_id!=undefined ? '&hcc=' + issue.health_class_id : '') + (issue.health_id && issue.health_id!='' ? '&hid=' + issue.health_id : '') + (issue.issue_company ? '&ic=' + issue.issue_company : '') + (issue.issue_bg_campaign ? '&il=' + issue.issue_bg_campaign : '') + (issue.issue_product ? '&io=' + issue.issue_product : '');
        issue.issue_hap_url = 'hap://app/' + QuickAppConfig[String(issue.app_id)]['pkg'] + '/pages/start?sip=' + sip + '&cid=' + issue.channel_id + '&csid=' + issue.channel_slot_id + '&QUICK_APP_ST_CHANNEL=' + issue.channel_slot_id + (issue.measure_id && issue.measure_id!='' ? '&mid=' + issue.measure_id + '&mtp=' + this.appraiseTemplets[issue.measure_id] : '') + (issue.book_id && issue.book_id!='' ? '&bid=' + issue.book_id + '&bnm=' + encodeURIComponent(this.bookNames[issue.book_id]) : '') + (issue.shortplay_id && issue.shortplay_id!='' ? '&vid=' + issue.shortplay_id : '') + (issue.cookbook_id && issue.cookbook_id!='' ? '&nid=' + issue.cookbook_id : '') + (issue.health_class_id!=undefined ? '&hcc=' + issue.health_class_id : '') + (issue.health_id && issue.health_id!='' ? '&hid=' + issue.health_id : '');    
      } else if(QuickAppConfig[String(issue.app_id)]['type']=='game') {
        issue.issue_h5_url = 'https://coscdn.' + QuickAppConfig[String(issue.app_id)]['domain'] + '.com' + QuickAppConfig[String(issue.app_id)]['path'] + QuickAppConfig[String(issue.app_id)]['name'] + '_' + target + '.html?sip=' + sip + '5&cid='+ issue.channel_id + '&csid=' + issue.channel_slot_id + (issue.measure_id && issue.measure_id!='' ? '&mid=' + issue.measure_id + '&mtp=' + this.appraiseTemplets[issue.measure_id] : '') + (issue.book_id && issue.book_id!='' ? '&bid=' + issue.book_id + '&bnm=' + encodeURIComponent(this.bookNames[issue.book_id]) : '') + (issue.shortplay_id && issue.shortplay_id!='' ? '&vid=' + issue.shortplay_id : '') + (issue.cookbook_id && issue.cookbook_id!='' ? '&nid=' + issue.cookbook_id : '') + (issue.health_class_id!=undefined ? '&hcc=' + issue.health_class_id : '') + (issue.health_id && issue.health_id!='' ? '&hid=' + issue.health_id : '') + (issue.issue_company ? '&ic=' + issue.issue_company : '') + (issue.issue_bg_campaign ? '&il=' + issue.issue_bg_campaign : '') + (issue.issue_product ? '&io=' + issue.issue_product : '');
        let addition = {
          'sip': sip,
          'cid': issue.channel_id,
          'csid' : issue.channel_slot_id,
        };
        if(issue.issue_platform=='oppo') {
          issue.issue_hap_url = 'hap://game/' + QuickAppConfig[String(issue.app_id)]['pkg'] + '.nearme.gamecenter?userEntry=902&in_one_task=true&_GEOS_=' + encodeURIComponent(JSON.stringify(addition));
        } else {
          issue.issue_hap_url = 'hap://app/' + QuickAppConfig[String(issue.app_id)]['pkg'] + '.nearme.gamecenter?userEntry=902&in_one_task=true&_GEOS_=' + encodeURIComponent(JSON.stringify(addition));
        }
      } else {
        issue.issue_hap_url = '';
        issue.issue_hap_url = '';
      }
      
      // 针对快手，hap连接增加参数
      if(issue.issue_platform=='kuaishou') {
        issue.issue_hap_url = issue.issue_hap_url + '&reqid=__CALLBACK__';
        issue.issue_h5_url = issue.issue_h5_url + '&reqid=__CALLBACK__';
      }

      // 针对趣头条，hap链接增加参数
      if(issue.issue_platform=='qtt') {
        issue.issue_hap_url = issue.issue_hap_url + '&callbackurl=__CALLBACK_URL__';
        issue.issue_h5_url = issue.issue_h5_url + '&callbackurl=__CALLBACK_URL__';
      }
      
      // 针对vivo，hap链接增加参数
      if(issue.issue_platform=='vivo') {
        issue.issue_hap_url = issue.issue_hap_url + '&reqid=__REQUESTID__';
      }

      // 针对iqiyi，链接增加参数
      if(issue.issue_platform=='iqiyi') {
        issue.issue_hap_url = issue.issue_hap_url + '&reqid=__IMPRESSS_ID__';
        issue.issue_h5_url = issue.issue_h5_url + '&reqid=__IMPRESSS_ID__';
      }

      // 针对OPPO平台，H5链接增加参数
      if(issue.issue_platform=='oppo') {
        issue.issue_h5_url = issue.issue_h5_url + '&ownerId=' + issue.issue_account;
      }

      // 针对头条，链接增加reqid参数
      if(issue.issue_platform=='toutiao') {
        issue.issue_h5_url = issue.issue_h5_url + '&reqid=__CLICKID__';
      }

      return true;
    },

    // 复制
    async copy(data) {
      // 验证参数有效性
      if(data.app_issue_id==null || data.app_issue_id==undefined) {
        return;
      }
      // 进入新增页面
      this.$router.push({name:'running.luckystat.issue.add',params:data});
    },

    // 新增
    async add() {
      // 进入新增页面
      this.$router.push({name:'running.luckystat.issue.add'});
    },
    addBatch() {
      // 进入新增页面
      this.$router.push({name:'running.luckystat.issue.batch'});
    },

    // 编辑
    async update(data) {
      // 验证参数有效性
      if(data.app_issue_id==null || data.app_issue_id==undefined) {
        return;
      }
      // 进入修改页面
      if(!data.issue_h5_url) {
        data.issue_h5_url = null;
      }
      if(!data.issue_hap_url) {
        data.issue_hap_url = null;
      }
      if(!data.issue_tc_url) {
        data.issue_tc_url = null;
      }
      if(!data.issue_tv_url) {
        data.issue_tv_url = null;
      }
      this.$router.push({name:'running.luckystat.issue.update',params:data});
    },

    // 删除
    async remove(data) {
      // 确认删除
      MessageBox.confirm('请确认是否删除当前快应用推广？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 显示页面加载
        const loading = this.$loading({
          lock: true,
          text: 'Processing ......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          target: '.box'
        });
        // 调用删除
        this.$api.apiQuickAppIssueDelete({appIssueId: data.app_issue_id}).then(res => {
          if (res.result === 1) {
            // 从data中移除这一项
            this.$delete(this.pageTable.tableData,this.pageTable.tableData.findIndex((item) => item.app_issue_id === data.app_issue_id));
            // 请求成功
            this.$message("删除成功", "success");
          } else {
            // 操作失败
            this.$message(res.message, "warning");
          }
        });
        // 关闭加载
        loading.close();
      }).catch(() => {});
    },
    
    // 变更当前页面
    async changeCurrPage(currPage) {
      this.pageTable.pageIndex = currPage;
      this.loadData();
    },

    // 变更页面大小
    async changePageSize(pageSize) {
      this.pageTable.pageSize = pageSize;
      this.pageTable.pageIndex = 1;
      this.loadData();
    },

    // 配置投放效果数据回传调整
    async configEffectModeChange() {
      // 效果数据回传模式
      this.effectModeSelected = [];
      this.effectModeSelected2 = [];
      if(this.formConfigEffect.effectMode) {
        this.formConfigEffect.effectMode = parseInt(this.formConfigEffect.effectMode);
        if(Math.floor(this.formConfigEffect.effectMode % 10) == 1) {
          this.effectModeSelected.push('广告点击');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10) % 10) == 1) {
          this.effectModeSelected.push('广告曝光');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 1) {
          this.effectModeSelected.push('用户ARPU');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 2) {
          this.effectModeSelected2.push('用户ARPU2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 1) {
          this.effectModeSelected.push('广告价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 2) {
          this.effectModeSelected2.push('广告价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000) % 10) == 1) {
          this.effectModeSelected.push('访问时长');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 1) {
          this.effectModeSelected.push('广告曝光&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 2) {
          this.effectModeSelected2.push('广告曝光&价格2');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 1) {
          this.effectModeSelected.push('ROI');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 2) {
          this.effectModeSelected2.push('收入ROI');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 10000000) % 10) == 1) {
          this.effectModeSelected2.push('广告点击&价格');
        }
        if(Math.floor((this.formConfigEffect.effectMode / 100000000) % 10) == 1) {
          this.effectModeSelected2.push('ROI修正');
        }
      }
    },

    // 配置渠道位置回传
    async configEffect(channelSlotId) {
      if(channelSlotId==null || channelSlotId==undefined) {
        this.$message("请选择具体渠道位置","warning");
        return;
      }
      // 显示页面加载
      const loading = this.$loading({
          lock: true,
          text: 'Processing ......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          target: '.box'
      });
      // 调用接口
      let res = await this.$api.apiCommonEffectGet({channelSlotId: channelSlotId});
      console.log(res);
      if(res.result==1) {
        this.formConfigEffect = res.content;
        this.dialogConfigEffectVisible = true;
        // 效果数据回传模式
        this.effectModeSelected = [];
        this.effectModeSelected2 = [];
        if(this.formConfigEffect.effectMode) {
          this.formConfigEffect.effectMode = parseInt(this.formConfigEffect.effectMode);
          if(Math.floor(this.formConfigEffect.effectMode % 10) == 1) {
            this.effectModeSelected.push('广告点击');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 10) % 10) == 1) {
            this.effectModeSelected.push('广告曝光');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 1) {
            this.effectModeSelected.push('用户ARPU');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100) % 10) == 2) {
            this.effectModeSelected2.push('用户ARPU2');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 1) {
            this.effectModeSelected.push('广告价格');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000) % 10) == 2) {
            this.effectModeSelected2.push('广告价格2');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 10000) % 10) == 1) {
            this.effectModeSelected.push('访问时长');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 1) {
            this.effectModeSelected.push('广告曝光&价格');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100000) % 10) == 2) {
            this.effectModeSelected2.push('广告曝光&价格2');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 1) {
            this.effectModeSelected.push('ROI');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 1000000) % 10) == 2) {
            this.effectModeSelected2.push('收入ROI');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 10000000) % 10) == 1) {
            this.effectModeSelected2.push('广告点击&价格');
          }
          if(Math.floor((this.formConfigEffect.effectMode / 100000000) % 10) == 1) {
            this.effectModeSelected2.push('ROI修正');
          }
        }
        // 效果回传比例
        if(this.formConfigEffect.effectRate) {
          this.formConfigEffect.effectRate = this.formConfigEffect.effectRate / 100;
        }
        // 效果回传价格
        if(this.formConfigEffect.effectArpu) {
          this.formConfigEffect.effectArpu = this.formConfigEffect.effectArpu / 10000.0;
        }
        if(this.formConfigEffect.effectArpu2) {
          this.formConfigEffect.effectArpu2 = this.formConfigEffect.effectArpu2 / 10000.0;
        }
        if(this.formConfigEffect.effectAdPrice) {
          this.formConfigEffect.effectAdPrice = this.formConfigEffect.effectAdPrice / 10000.0;
        }
        if(this.formConfigEffect.effectRoi) {
          this.formConfigEffect.effectRoi = this.formConfigEffect.effectRoi / 10000.0;
        }
        // 效果回传忽略设备
        if((this.formConfigEffect.effectIgnore & 1) == 1) {
          this.effectIgnoreOppo = true;
        } else {
          this.effectIgnoreOppo = false;
        }
        if((this.formConfigEffect.effectIgnore & 2) == 2) {
          this.effectIgnoreVivo = true;
        } else {
          this.effectIgnoreVivo = false;
        }
        // 统一回传
        if(this.formConfigEffect.effectUnify == 1) {
          this.effectUnifySwitch = true;
        } else {
          this.effectUnifySwitch = false;
        }
      }
      // 关闭加载
      loading.close();
    },
    
    async onCancelConfigEffect() {
      this.dialogConfigEffectVisible = false;
    },

    async submitConfigEffect(form){
      // 验证表单数据
      this.$refs[form].validate((valid) => {
          if (valid) {
            // 显示页面加载
            const loading = this.$loading({
                lock: true,
                text: 'Processing ......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
                target: '.box'
            });
            // 设置效果回传模式
            let selectedArpu = 0;
            let selectedArpu2 = 0;
            let selectedAdPrice = 0;
            let selectedAdPrice2 = 0;
            let selectedAdPriceView = 0;
            let selectedAdPriceView2 = 0;
            let selectedROI = 0;
            let selectedIncomeRoi = 0;
            let selectedROIAmend = 0;
            this.formConfigEffect.effectMode = 0;
            for(let mode of this.effectModeSelected) {
              if(mode == '广告点击') {
                this.formConfigEffect.effectMode += 1;
              } else if(mode == '广告曝光') {
                this.formConfigEffect.effectMode += 10;
              } else if(mode == '用户ARPU') {
                this.formConfigEffect.effectMode += 100;
                selectedArpu = 1;
              } else if(mode == '广告价格') {
                this.formConfigEffect.effectMode += 1000;
                selectedAdPrice = 1;
              } else if(mode == '访问时长') {
                this.formConfigEffect.effectMode += 10000;
              } else if(mode == '广告曝光&价格') {
                this.formConfigEffect.effectMode += 100000;
                selectedAdPriceView = 1;
              } else if(mode == 'ROI') {
                selectedROI = 1;
                this.formConfigEffect.effectMode += 1000000;
              }
            }
            for(let mode of this.effectModeSelected2) {
              if(mode == '用户ARPU2') {
                this.formConfigEffect.effectMode += 200;
                selectedArpu2 = 1;
              } else if(mode == '广告价格2') {
                this.formConfigEffect.effectMode += 2000;
                selectedAdPrice2 = 1;
              } else if(mode == '广告曝光&价格2') {
                this.formConfigEffect.effectMode += 200000;
                selectedAdPriceView2 = 1;
              } else if(mode == '广告点击&价格') {
                this.formConfigEffect.effectMode += 10000000;
              } else if(mode == '收入ROI') {
                this.formConfigEffect.effectMode += 2000000;
                selectedIncomeRoi = 1;
              } else if(mode == 'ROI修正') {
                selectedROIAmend = 1;
                this.formConfigEffect.effectMode += 100000000;
              }
            }
            // 校验选择合理性
            if(selectedArpu==1 && selectedArpu2==1
                || selectedAdPrice==1 && selectedAdPrice2==1
                || selectedAdPriceView==1 && selectedAdPriceView2==1
                || selectedROI==1 && (selectedIncomeRoi==1 || selectedROIAmend==1)
                || selectedIncomeRoi==1 && (selectedROI==1 || selectedROIAmend==1)
                || selectedROIAmend==1 && (selectedROI==1 || selectedIncomeRoi==1)
              ) {
              this.$message('回调模式选择冲突', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // 广告曝光和价格与广告价格不能同时选择
            if((selectedAdPrice==1 || selectedAdPrice2==1) && (selectedAdPriceView==1 || selectedAdPriceView2==1)) {
              this.$message('回调模式选择冲突', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // roi 必须跟其他模式并存
            if(this.formConfigEffect.effectMode == 1000000 || this.formConfigEffect.effectMode == 2000000 || this.formConfigEffect.effectMode == 100000000) {
              this.$message('ROI回传模型必须与其他模式并存', "warning");
              // 关闭加载
              loading.close();
              return;
            }
            // 回传比例
            this.formConfigEffect.effectRate = Math.floor(this.formConfigEffect.effectRate * 100);
            // 效果回传价格
            if(this.formConfigEffect.effectArpu) {
              this.formConfigEffect.effectArpu = Math.floor(this.formConfigEffect.effectArpu * 10000);
            }
            if(this.formConfigEffect.effectArpu2) {
              this.formConfigEffect.effectArpu2 = Math.floor(this.formConfigEffect.effectArpu2 * 10000);
            }
            if(this.formConfigEffect.effectAdPrice) {
              this.formConfigEffect.effectAdPrice = Math.floor(this.formConfigEffect.effectAdPrice * 10000);
            }
            if(this.formConfigEffect.effectDuration) {
              this.formConfigEffect.effectDuration = Math.floor(this.formConfigEffect.effectDuration);
            }
            if(this.formConfigEffect.effectRoi && this.formConfigEffect.effectRoi > 0) {
              this.formConfigEffect.effectRate = 0;  // ROI 回传模型轮询回传比例为 0%
              this.formConfigEffect.effectRoi = Math.floor(this.formConfigEffect.effectRoi * 10000);
            }
            // 忽略设备
            this.formConfigEffect.effectIgnore = 0;
            if(this.effectIgnoreOppo) {
              this.formConfigEffect.effectIgnore += 1;
            }
            if(this.effectIgnoreVivo) {
              this.formConfigEffect.effectIgnore += 2;
            }
            // 统一回传
            if(this.effectUnifySwitch) {
              this.formConfigEffect.effectUnify = 1;
            } else {
              this.formConfigEffect.effectUnify = 0;
            }
            // 设置操作员ID
            let operator = JSON.parse(localStorage.getItem('operator'));
            this.formConfigEffect.operatorId = operator.operatorId;
            // 提交保存
            this.$api.apiCommonEffectSet(this.formConfigEffect).then (res => {
                if (res.result === 1) {
                    // 请求成功
                    this.$message("保存效果数据回传设置成功", "success");
                } else {
                    this.$message(res.message, "warning");
                }
            });
            // 关闭加载
            loading.close();
            // 关闭弹窗
            this.dialogConfigEffectVisible = false;
          }
      });
    },

    async changeChannelSlot() {
      this.editChannelSlotId = this.formConfigEffect.channelSlotId;
      this.editStatChanneSlot = true;
    },

    async confirmChannelSlot() {
      this.editStatChanneSlot = false;
      this.configEffect(this.formConfigEffect.channelSlotId);
    },
    
    async cancelChannelSlot() {
      this.formConfigEffect.channelSlotId = this.editChannelSlotId;
      this.editStatChanneSlot = false;
    },

    // 操作日志
    async showOperateLogs() {
      this.dialogOperateLogVisible = true;
      this.loadOperateLogs();
    },

    async loadOperateLogs() {
      // 显示页面加载
      const loading = this.$loading({
        lock: true,//lock的修改符--默认是false
        text: 'Loading',//显示在加载图标下方的加载文案
        spinner: 'el-icon-loading',//自定义加载图标类名
        background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
        target: '.box'//遮罩区域
      });
      // 获取请求参数
      let params = new Object();
      params['pageIndex'] = this.operateLogs.pageIndex;
      params['pageSize'] = this.operateLogs.pageSize;
      params['beginDate'] = getBeforeDate(this.operateLogs.dateRange);
      params['endDate'] = getCurrDate();
      params['changeTarget'] = 'APP_EFFECT';
      params['changeType'] = 'redis';
      params['changeParam1Key'] = 'csid';
      params['changeParam1Value'] = this.formConfigEffect.channelSlotId;
      // 调用接口
      let res = await this.$api.apiCommonOperateLogs(params);
      if(res.result !== 1) {
        this.$message("加载操作日志失败","warning");
        // 加载结束
        loading.close();
        return;
      }
      // 获取分页数据
      this.operateLogs.pageIndex = res.content.pageIndex;
      this.operateLogs.pageSize = res.content.pageSize;
      this.operateLogs.pageCount = res.content.pageCount;
      this.operateLogs.recordTotalCount = res.content.recordTotalCount;
      // 应用数据存进data
      this.operateLogs.tableData = res.content.records;
      // 加载结束
      loading.close();
    },
    
    async changeOperateLogCurrPage(currPage) {
      this.operateLogs.pageIndex = currPage;
      this.loadOperateLogs();
    },

    async changeOperateLogPageSize(pageSize) {
      this.operateLogs.pageSize = pageSize;
      this.operateLogs.pageIndex = 1;
      this.loadOperateLogs();
    },

  },
};
</script>
<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.work {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right:5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.condition {
  margin: 10px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  flex-direction: row column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_line {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row column;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.condi_item {
  margin-left: 30px;
  width: 240px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_max {
  margin-left: 30px;
  width: 310px;
  height: 36px;
  display: flex;
  align-items: center;
}
.condi_item_label {
  text-align: left;
  width: 80px;
  font-size: 16px;
}
.condi_item_cnt {
  width: 160px;
  font-size: 16px;
}
.condi_item_cnt_max {
  width: 230px;
  font-size: 16px;
}
.condi_item_cnt .el-input {
  width: 160px;
}
.condi_item_cnt_max .el-input {
  width: 230px;
}
.condi_item_cnt .el-select {
  width: 160px;
}
.condi_item_cnt_max .el-select {
  width: 230px;
}
.condi_item_cnt .el-button {
  width: 160px;
}
.condi_item_cnt_max .el-date-picker {
  width: 230px;
}
.datalist {
  margin: 0px 10px 10px 10px;
  padding: 5px 5px 5px 5px;
  width: 98%;
  height: auto;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  flex-direction: row;
  border-radius: 9px;
  overflow: auto;
  background: #fff;
}
.datalist .el-table {
  margin: 0 auto;
  width: 96%;
}
.dtlst_top {
  margin: 10px 10px 10px 15px;
  width: 96%;
  height: 25px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  align-items: center;
  background: #fff;
}
.dtlst_title {
  color: black;
  font-size: 1rem;
  font-weight: 500;
  height: 25px;
  text-align: left;
}
.dtlst_btn {
  height: 20px;
  width: calc(100% - 100px);
  text-align: right;
}
.dtlst_btn .el-button {
  margin: 0px 0px 0px 10px;
  padding: 0px 10px 0px 10px;
  color: white;
  background: #1890ff;
  height: 25px;
  min-width: 80px;
  width: auto;
}
.dtlst_table {
  width: 98%;
  height: auto;
}
.dtlst_operation {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.dtlst_pagination {
  margin: 0 auto;
  width: 96%;
  height: 25px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>